import React from 'react';

import { SelectField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import booleanChoices from '../../../../constants/booleanChoices';
import conflictFields from '../../../../constants/conflictFields';
import { BooleanQuestionParameters } from '../../questionParameters';
import applyChoices from '../../applyChoices';

const CONTENT = {
  [languages.SV]: 'Är företaget en finansiell institution?',
  [languages.EN]: 'Is The Company a Financial Institution?',
  [languages.DE]: 'Ist das Unternehmen ein Finanzinstitut?',
};

const ValueField = ({
  language,
  extraParameters,
}: {
  language?: Languages;
  extraParameters?: BooleanQuestionParameters;
}) => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (!language) return null;

  return (
    <SelectField
      choices={applyChoices(
        booleanChoices[language],
        extraParameters?.options,
        extraParameters?.choiceLabels,
      )}
      record={{ value }}
      sx={sx}
      source="value"
      emptyText="-"
      fontWeight="bold"
    />
  );
};

const IsFinancialInstitution = ({
  extraParameters,
}: {
  extraParameters?: BooleanQuestionParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source="isFinancialInstitution"
      datapoint={conflictFields.IS_FINANCIAL_INSTITUTION}
      identificationInfo={undefined}
    >
      <ValueField language={language} extraParameters={extraParameters} />
    </Answer>
  );
};

IsFinancialInstitution.ValueField = ValueField;

export default IsFinancialInstitution;
